import { gql } from '@apollo/client';

import { apolloClient } from 'src/lib/apollo-client';

import * as ActionTypes from '../action-types';

const CREATE_FOLDER_MUTATION = gql`
  mutation createFolder($input: FolderCreateInput!) {
    createFolder(input: $input) {
      id
      name
      color
      updated_at
    }
  }
`;

interface CreateFolderInput {
  name: string;
  color: string;
  parentId: string;
  workspaceId: string;
}

interface CreateFolderResponse {
  createFolder: {
    id: string;
    name: string;
    color: string;
    updated_at: string;
  };
}

export function createFolder(input: CreateFolderInput) {
  return async (dispatchFn: any) => {
    // Generate temporary ID for optimistic update
    const tempId = `temp-${Date.now()}-${Math.random()}`;

    // Optimistic update: add folder immediately with temp ID
    dispatchFn({
      type: ActionTypes.FOLDER_CREATE_REQUEST,
      payload: {
        tempId,
        name: input.name,
        parent_id: input.parentId,
        workspace_id: input.workspaceId,
        color: input.color,
      },
    });

    try {
      const { data } = await apolloClient.mutate<CreateFolderResponse>({
        mutation: CREATE_FOLDER_MUTATION,
        variables: {
          input: {
            name: input.name,
            color: input.color,
            parentId: input.parentId,
            workspaceId: input.workspaceId,
          },
        },
      });

      if (!data?.createFolder) {
        throw new Error('Failed to create folder: no data returned');
      }

      // Replace temp ID with real ID from server
      dispatchFn({
        type: ActionTypes.FOLDER_CREATE_SUCCESS,
        payload: {
          tempId,
          id: data.createFolder.id,
          name: data.createFolder.name,
          parent_id: input.parentId,
          workspace_id: input.workspaceId,
          color: data.createFolder.color,
        },
      });

      return data.createFolder;
    } catch (error) {
      // Rollback optimistic update
      dispatchFn({
        type: ActionTypes.FOLDER_CREATE_FAILURE,
        payload: {
          tempId,
          error: error as Error,
        },
      });
      throw error;
    }
  };
}
